export default function (notification) {
	return this.html.element({
		tag: 'div',
		classes: ['notifications__item', 'notification', 'notification--' + notification.type],
		content: this.html.element({tag: 'div', classes: ['notification__container'], content:
			this.html.element({tag: 'div', classes: ['notification__text'], content: ('html' in notification ? notification.html : this.escape(notification.text))})
		})
	});
}
